/** Маска и проверка телефона — как в admin/admin.js для ресторанов. */
export function formatPhoneNumber(value) {
    let digits = String(value || '').replace(/\D/g, '');
    if (!digits)
        return '';
    if (digits.startsWith('8')) {
        digits = `7${digits.slice(1)}`;
    }
    if (!digits.startsWith('7')) {
        digits = `7${digits}`;
    }
    digits = digits.slice(0, 11);
    const parts = digits.slice(1).split('');
    const chunk = (start, end) => parts.slice(start, end).join('');
    let formatted = '+7';
    if (parts.length > 0)
        formatted += ` (${chunk(0, 3)}`;
    if (parts.length >= 3)
        formatted += ')';
    if (parts.length > 3)
        formatted += ` ${chunk(3, 6)}`;
    if (parts.length > 6)
        formatted += ` ${chunk(6, 8)}`;
    if (parts.length > 8)
        formatted += ` ${chunk(8, 10)}`;
    return formatted.trim();
}
export function isPhoneComplete(value) {
    const digits = String(value || '').replace(/\D/g, '');
    return digits.length === 11 && digits.startsWith('7');
}
export const PHONE_FORMAT_HINT = '+7 (999) 123 45 67';
